var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"row-total-card-previus-sales m-b-15 j-start"},[_c('total'),_c('btn-guardar'),_c('check-sale'),_c('advertencia-guardar-como-presupuesto'),_c('advertencia-cuenta-corriente')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }